/**
 * @file PickupPointDetails.tsx
 * @description Подробности пункта выдачи и его бейджи (phase19.12).
 *
 * Вынесено из ShopPickupPointsPage: тот же блок нужен в диалоге выбора пункта
 * сдачи на карте (настройки перевозчика) — один вид пункта на всю админку.
 */

import { Badge } from "../ui/badge";
import type { ShopPickupPointDto } from "../../lib/api-shop-carriers";

export function PickupPointBadges({ point }: { point: ShopPickupPointDto }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-sm font-medium">{point.externalCode}</span>
      <Badge variant="outline" className="py-0 text-[10px]">
        {point.carrier}
      </Badge>
      {point.hasCashPay ? (
        <Badge variant="secondary" className="py-0 text-[10px]">
          COD
        </Badge>
      ) : null}
      {!point.isActive ? (
        <Badge variant="outline" className="py-0 text-[10px] opacity-60">
          закрыт
        </Badge>
      ) : null}
    </div>
  );
}

export function PickupPointDetails({ point }: { point: ShopPickupPointDto }) {
  return (
    <div className="flex flex-col gap-2">
      <PickupPointBadges point={point} />
      <div className="text-sm">{point.address}</div>
      <div className="text-xs text-on-surface-variant">{point.city}</div>
      {point.workingHours ? (
        <div className="text-xs text-on-surface-variant">{point.workingHours}</div>
      ) : null}
      {/* Контакты пункта — кликабельные: с телефона менеджера удобно звонить. */}
      {point.phone ? (
        <a href={`tel:${point.phone}`} className="self-start text-xs text-primary hover:underline">
          {point.phone}
        </a>
      ) : null}
      {point.email ? (
        <a
          href={`mailto:${point.email}`}
          className="self-start text-xs text-primary hover:underline"
        >
          {point.email}
        </a>
      ) : null}
      {point.lat !== null && point.lng !== null ? (
        <div className="text-xs text-on-surface-variant">
          {point.lat.toFixed(5)}, {point.lng.toFixed(5)}
        </div>
      ) : (
        <div className="text-xs text-amber-600">Нет координат — точка не видна на карте</div>
      )}
    </div>
  );
}
